export enum AppMode {
  Full,
  UtilitySwitchingAgent,
  UtilitySwitchingCouncil,
}
